import {
	AuthenticatedTemplate,
	UnauthenticatedTemplate,
	useIsAuthenticated,
} from '@azure/msal-react';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useRecoilState } from 'recoil';

import Login from '../../pages/Login';
import api from '../../services/apiSgft';
import { actualUserAtom } from '../../state/ActualUser.atom';
import { AuthTemplate } from './AuthTemplate';

const RootLayout = () => {
	const isAuthenticated = useIsAuthenticated();
	const [, setActualUser] = useRecoilState(actualUserAtom);
	async function getUserInfo() {
		try {
			const response = await api.get('/employees/info');
			setActualUser(response.data);
			localStorage.setItem('employee', JSON.stringify(response.data));
		} catch (error) {
			toast.error('Erro ao carregar informações do usuário', {
				theme: 'colored',
				toastId: 'error',
			});
			throw error;
		}
	}
	useEffect(() => {
		if (isAuthenticated) {
			getUserInfo();
		}
	}, [isAuthenticated]);
	return (
		<>
			<AuthenticatedTemplate>
				<AuthTemplate />
			</AuthenticatedTemplate>

			<UnauthenticatedTemplate>
				<Login redirectHome={false} />
			</UnauthenticatedTemplate>
		</>
	);
};

export default RootLayout;
